<ng-container *ngIf="model">
  <li
    data-cy="result-bullet-item"
    class="bullet-container"
    [tooltipDisabled]="!tooltipText"
    [pTooltip]="tooltipText | toggleTooltipText: 'Copied!' : 1000 : tooltip : toggleCopyTooltip() | async"
    tooltipPosition="bottom"
    tooltipStyleClass="u-tooltip fit-content"
    #bullet
  >
    <u-icon
      data-cy="result-bullet-icon"
      *ngIf="model.icon && !iconError"
      class="bullet-icon undraggable"
      [model]="iconModel"
      [fallback]="fallback"
      [ngClass]="{ rounded: model.icon?.rounded, large: model.icon?.size === 'large' }"
    ></u-icon>

    <u-emoji class="emoji" *ngIf="model?.emoji" [spriteEmojiSize]="16" [unicode]="model?.emoji"> </u-emoji>

    <span
      data-cy="result-bullet-text"
      class="bullet-text"
      (click)="onCopyContent()"
      *ngIf="model.text"
      [innerHtml]="model.text | highlight: highlights : highlightStyle"
      tabindex="-1"
    ></span>
  </li>

  <dropdown #dropdown *ngIf="hasDropdown" [model]="model.dropdown" (invoke)="sendCommand($event)"></dropdown>
</ng-container>
